import type { FormatterFactory } from '../types';
import { withoutFloatNoise } from '../gridI18n';

export interface NumberOptions {
  decimals?: number;
  minDecimals?: number;
}

export const number: FormatterFactory = (options: NumberOptions = {}) => ({
  toText: (value) => {
    if (value == null || value === '') {
      return '';
    }
    const i18n = (globalThis as any).$app?.i18n;
    if (i18n) {
      return i18n.formatNumber(withoutFloatNoise(value), options);
    }
    return String(value);
  },

  toValue: (value) => {
    if (value == null || value === '') {
      return null;
    }
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : String(value);
  },
});
